<atlas-modal>
  @if (modalContent$ | async; as modalContent) {
    <atlas-modal-content>
      <p class="prompt-text" [innerHTML]="modalContent.promptText"></p>
    </atlas-modal-content>
    <atlas-modal-footer>
      @if (browserLanguage) {
        <atlas-button (onClick)="setBrowserLang()">
          {{ modalContent.browserButtonText }}
        </atlas-button>
      }
      <atlas-button (onClick)="confirmUserLang(modalContent.userLanguageCode)">
        {{ modalContent.userButtonText }}
      </atlas-button>
      <atlas-button (onClick)="openLanguageSelector()">
        {{ modalContent.seeOptionsButtonText }}
      </atlas-button>
    </atlas-modal-footer>
  } @else {
    <atlas-loader [size]="50"></atlas-loader>
  }
</atlas-modal>